import { useEffect, useState } from "react";

export function useIsFirefox(): boolean {
  const [isFirefox, setIsFirefox] = useState(false);

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    setIsFirefox(userAgent.includes("firefox"));
  }, []);

  return isFirefox;
}
